import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { TallyCompany } from '../../../../../types/tally';

interface DefaultActionsProps {
  company: TallyCompany;
  onFetchDetails: (company: TallyCompany) => void;
  onAddCompany: (company: TallyCompany) => void;
  onEditGst: (companyName: string) => void;
}

const DefaultActions: React.FC<DefaultActionsProps> = ({
  company,
  onFetchDetails,
  onAddCompany,
  onEditGst,
}) => {
  return (
    <>
      <Button
        variant="outlined"
        onClick={() => onFetchDetails(company)}
        disabled={company.loading}
        size="small">
        {company.loading ? <CircularProgress size={20} /> : 'Fetch Details'}
      </Button>
      {company.detailsFetched && (
        <Button
          variant="outlined"
          onClick={() => onAddCompany(company)}
          size="small">
          Add Company
        </Button>
      )}
      <Button
        variant="outlined"
        onClick={() => onEditGst(company.name)}
        size="small">
        Edit
      </Button>
    </>
  );
};

export default DefaultActions;
